import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, Inject, NgZone, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs';
import { MyErrorStateMatcher } from 'src/app/auth/login/login.component';
import { ContractService } from '../../shared/contract.service';

@Component({
  selector: 'app-reject-dialog',
  templateUrl: './reject-dialog.component.html',
  styleUrl: './reject-dialog.component.css'
})
export class RejectDialogComponent {
  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  rejectForm: FormGroup;
  matcher = new MyErrorStateMatcher();
  isLoading: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private toast: ToastrService, private dialog: MatDialog, private contractService: ContractService, private _ngZone: NgZone,) {
    this.rejectForm = new FormGroup({
      rejectReason: new FormControl('', [Validators.required]),
    });
  }

  triggerResize() {
    this._ngZone.onStable.pipe(take(1)).subscribe(() => this.autosize.resizeToFitContent(true));
  }

  async reject() {
    if (this.rejectForm.valid) {
      this.isLoading = true;
      try {
        if(this.data.tileId == 3){
        await this.contractService
          .rejectContract(this.data.contractId, this.rejectForm.get('rejectReason').value)
          .then(() => {
            this.toast.success('Contract Rejected Successfully!', '');
          });
        } else {
          await this.contractService
          .declineContract(this.data.contractId, this.rejectForm.get('rejectReason').value)
          .then(() => {
            this.toast.success('Contract Declined Successfully!', '');
          });
        }

          this.isLoading = false;
          this.dialog.closeAll();
          this.data.initialize();
          this.rejectForm.reset();
      } catch (error) {
        console.error(this.data.tileId == 3 ? 'Reject failed' : 'Decline failed', error);
        this.toast.error(
          this.contractService.describeError(error) ||
          'Something went wrong, Please try again later!',
          this.data.tileId == 3 ? 'Reject failed' : 'Decline failed'
        );
        this.isLoading = false;
      }
    }
  }
}
